import { useGenericRequestHandler } from '../../../handlers'

const endpoint = 'v1/m/loop'

/**
 * @typedef {Object} MoteLoopPayload
 * @property {number} step
 * @property {string} seenMeme
 * @property {ToteEngagementMode} mode
 */

/**
 * @param {string} moteId
 * @return {{[p: string]: *}}
 */
export function useMoteLoopMutation(moteId) {
  return useGenericRequestHandler({
    route: endpoint + `/${moteId}`,
    method: 'POST'
  })
}
